import RateView from './RateView'

export default RateView
